import { Flex, Heading, Image, useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import React, { useEffect } from 'react';

import { login } from './authTokenUtils';
import { LoginForm } from './LoginForm';
import { errorToastConfig } from '~/packages/common-frontend/constants';

// Exports
type LoginPageContainerProps = {
  children?: React.ReactNode;
  logoSrc: string;
};
export const LoginPageContainer = ({
  children,
  logoSrc,
}: LoginPageContainerProps) => {
  // Form submission
  const toast = useToast();
  const mutation = useMutation({ mutationFn: login });
  useEffect(() => {
    if (mutation.error && axios.isAxiosError(mutation.error)) {
      toast({
        ...errorToastConfig,
        title: mutation.error.response?.data.message || mutation.error.message,
      });
    }
  }, [mutation.error, toast]);

  return (
    <Flex
      align="center"
      direction="column"
      height="100vh"
      justify="center"
      width="100vw"
    >
      <Flex
        direction="column"
        gap="2.25rem"
        width={['100%', '380px', '400px', '440px']}
      >
        <Flex justifyContent="center" padding="0 1.5rem" width="100%">
          <Image src={logoSrc} alt="Logo" height="2.5rem" />
        </Flex>
        <Flex
          direction="column"
          gap="1.875rem"
          minHeight="240px"
          padding="0 1.25rem"
          position="relative"
          textAlign="center"
          width="100%"
        >
          <Heading as="h4" size="md" textAlign="left">
            Sign In
          </Heading>
          <Flex direction="column">
            <LoginForm
              onSubmit={async (formValues) => {
                await mutation.mutate(formValues);
              }}
            />
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
